import { graphql } from "api/cms-website/generated";

import { ButtonFragment } from "../primitives/button";
import { ResponsiveImageFragment } from "../primitives/responsiveImage";

export const TextWithCTAFragment = graphql(/* GraphQL */ `
    fragment TextWithCTAFragment on ComponentComponentsTextWithCta {
        id
        noMarginBottom
        textWithCtaBaseTitle: title
        textWithCtaBaseText: text
        textWithCtaBaseCta: cta {
            ...ButtonFragment
        }
        textWithCtaBaseImage: image {
            ...ResponsiveImageFragment
        }
    }
    ${ButtonFragment}
    ${ResponsiveImageFragment}
`);
